import { Form, Formik } from "formik";
import FormikControl from "../../Formik/FormikControl";
import ITournamentGroup from "../../Interfaces/TournamentGroup";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

type Props = {
  group: ITournamentGroup;
  loading?: boolean;
  onSubmit: (group: {
    name: string;
    index?: number;
    pointSystem: {
      pointsPerWin: number;
      pointsPerLose: number;
      pointsPerDraw: number;
    };
  }) => void;
};

const EditTournamentGroupMondal = ({ loading, group, ...props }: Props) => {
  const { t } = useTranslation();

  const initialValues = {
    name: group.name,
    index: group.index ?? "",
    pointSystem: {
      pointsPerWin: group.pointSystem.pointsPerWin,
      pointsPerLose: group.pointSystem.pointsPerLose,
      pointsPerDraw: group.pointSystem.pointsPerDraw,
    },
  };

  const onSubmit = (values: any) => {
    props.onSubmit({
      ...values,
      index: values.index === "" ? undefined : Number(values.index),
    });
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(t("yup.fieldRequired")),
    index: Yup.number().nullable().min(0, t("yup.fieldRequired")),
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ isValid }) => (
        <Form>
          <div className="container">
            <div className="space-divider-20"></div>
            <div className="columns skp-text-primary">
              <div className="column col-12">
                <FormikControl
                  control="input"
                  label={t("common.name")}
                  name="name"
                  placeholder={t("teams.create.teamName")}
                />
              </div>

              <div className="column col-12">
                <FormikControl
                  control="input"
                  type="number"
                  label={t("common.position")}
                  name="index"
                  placeholder="0, 1, 2..."
                />
              </div>

              <div className="column col-12">
                <h6 className="skp-text-light">{t("tabs.pointSystem")}</h6>
              </div>

              <div className="column col-12">
                <div className="columns">
                  <div className="column col-4">
                    <FormikControl
                      control="input"
                      type="number"
                      label={t("pointSystem.pointsPerWin")}
                      name="pointSystem.pointsPerWin"
                    />
                  </div>
                  <div className="column col-4">
                    <FormikControl
                      control="input"
                      type="number"
                      label={t("pointSystem.pointsPerDraw")}
                      name="pointSystem.pointsPerDraw"
                    />
                  </div>
                  <div className="column col-4">
                    <FormikControl
                      control="input"
                      type="number"
                      label={t("pointSystem.pointsPerLose")}
                      name="pointSystem.pointsPerLose"
                    />
                  </div>
                </div>
              </div>

              <div className="column col-12 text-right">
                <button
                  className="skp-btn skp-btn-primary"
                  disabled={loading || !isValid}
                >
                  {t("common.saveChanges")}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default EditTournamentGroupMondal;
